import { render, staticRenderFns } from "./HeaderArtist.vue?vue&type=template&id=413bf860&scoped=true"
import script from "./HeaderArtist.vue?vue&type=script&lang=js"
export * from "./HeaderArtist.vue?vue&type=script&lang=js"
import style0 from "./HeaderArtist.vue?vue&type=style&index=0&id=413bf860&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413bf860",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/elements/Button.vue').default})
